export default {
  primary: "white",
  accent: "#6fc2ce",
  background: "black"
};
